module.exports = __webpack_public_path__ + "img/wallet_mb_03.067f2157.png";